
/* A SKANU: Lithuanian labels for the Parcely storefront widget.
   Translates visible text only; never replaces widget DOM or intercepts app interactions. */
(() => {
  const phrases = new Map([
    ['Please choose a shipping method','Pasirinkite pristatymo būdą'],
    ['Please select a service provider','Pasirinkite vežėją'],
    ['Delivery to locker or pick-up point','Pristatymas į paštomatą'],
    ['Omniva parcel lockers','Omniva paštomatai'],
    ['DPD parcel lockers','DPD paštomatai'],
    ['LP express parcel lockers','LP EXPRESS paštomatai'],
    ['Please select a pick-up point','Pasirinkite paštomatą'],
    ['Select pick-up point','Pasirinkti paštomatą'],
    ['Select a location','Pasirinkite vietą']
  ]);
  const sectionFragment = '17924713818f290a28';
  function translate(section) {
    const walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const p=node.parentElement;
        return p && !p.closest('script,style,textarea') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    let n;
    while ((n = walker.nextNode())) {
      const raw = n.nodeValue || '';
      const key=raw.trim();
      const replacement=phrases.get(key);
      if (replacement && replacement!==key) {
        const first=raw.indexOf(key);
        n.nodeValue=raw.slice(0,first)+replacement+raw.slice(first+key.length);
      }
    }
    section.querySelectorAll('input[placeholder]').forEach((el)=>{
      const old=el.getAttribute('placeholder');
      if(old==='Search...'||old==='Search')el.setAttribute('placeholder','Ieškoti paštomato...');
      if(old==='Filter Carriers')el.setAttribute('placeholder','Filtruoti vežėjus');
    });
  }
  function start() {
    const main=document.querySelector('#MainContent[data-template="cart"]');
    if(!main)return;
    const section=Array.from(main.children).find(el=>el.id && el.id.includes(sectionFragment));
    if(!section)return;
    let queued=false;
    const refresh=()=>{
      if(queued)return;
      queued=true;
      requestAnimationFrame(()=>{
        queued=false;
        translate(section);
      });
    };
    refresh();
    const observer=new MutationObserver(refresh);
    observer.observe(section,{childList:true,subtree:true});
  }
  if (document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
